import React, { useEffect } from 'react';
import { useApolloClient, useMutation } from '@apollo/client';
import { message } from 'antd';
import { GET_AUTH, LOGOUT } from '../../gql/auth';

const Logout = () => {
  const client = useApolloClient();
  const [isPassword, setIsPassword] = React.useState(false);
  const [logout, { loading }] = useMutation(LOGOUT, {
    update: (cache) => {
      cache.writeQuery({
        query: GET_AUTH,
        data: {
          auth: { token: '', isLoggedIn: false, loading: false, me: null },
        },
      });
    },
    onCompleted: (data) => {
      localStorage.removeItem('token');
      client.resetStore().then(() => {
        client.cache.writeQuery({
          query: GET_AUTH,
          data: {
            auth: { token: '', isLoggedIn: false, loading: false, me: null },
          },
        });
        message.success('logouted');
        if (data?.logout === 'DIRECTORY') {
          window.location.href = process.env.REACT_APP_LOGOUT_URL;
        } else {
          setIsPassword(true);
        }
      });
    },
  });

  useEffect(() => {
    logout();
  }, [logout]);

  return loading || !isPassword ? (
    <div>Signing out...</div>
  ) : (
    <>
      <h3>You signed out of your account</h3>
      <div>It's a good idea to close all browser windows.</div>
    </>
  );
};

export default Logout;
